export default __webpack_public_path__ + "static/media/9.49d1bf45.png";